import { SET_ME, CLEAR_ME } from "./actions"

const INITIAL_STATE = {
  me: null,
  initialized: false,
}

export default function meReducer(state = INITIAL_STATE, action: any) {
  switch (action.type) {
    case SET_ME:
      return { ...state, me: action.user, initialized: action.initialized }
    case CLEAR_ME: // Agrega el case para CLEAR_ME
      return { ...state, me: null, initialized: false }
    default:
      return state
  }
}
